export default "__VITE_ASSET__02fed236__"